import { FC } from "react";
import { Box, Heading } from "@chakra-ui/react";

import { useSbpTransferAllowed } from "../../SbpTransfer/hooks";
import { MainPageSbpTransferButton } from "./MainPageSbpTransferButton";
import { MainPageSbpTransferContent } from "./MainPageSbpTransferContent";

interface Props {
  limitStatus: string | undefined;
  isCoolingFetching: boolean;
  isCoolingActive: boolean | undefined;
}

export const MainPageSbpTransfer: FC<Props> = ({ limitStatus, isCoolingFetching, isCoolingActive }) => {
  const show = useSbpTransferAllowed() && limitStatus === "ACTIVE";

  if (!show) {
    return null;
  }

  return (
    <Box px="20px" py="12px" bg="white" borderRadius="16px">
      <Heading mt="6px" mb="5px">Перевести себе на счет</Heading>

      <MainPageSbpTransferContent isCoolingFetching={isCoolingFetching} isCoolingActive={isCoolingActive} />
      <MainPageSbpTransferButton isCoolingFetching={isCoolingFetching} isCoolingActive={isCoolingActive} />
    </Box>
  );
};
